module.exports = __webpack_public_path__ + "img/m-nex32-menu-desktop.a447d226.jpg";